import { Modal } from "react-bootstrap";
import { useState, useEffect } from "react";
import Styles from "./AddressListModal.module.css";
import deleteIcon from "../Assets/delete_primary.png";
import plusIcon from "../Assets/plus.png";
import {
  BILLING_ADDRESS_LIST_KEY,
  SHIPPING_ADDRESS_LIST_KEY,
} from "../Utility/Utility";

export default function AddressListModal({
  show,
  onHide,
  onNew,
  onUpdate,
  isSave,
  isBilling,
  list = [],
  onSelectAddress,
  onRefreshAddressList,
}) {
  const [addressList, setAddressList] = useState([]);

  useEffect(() => {
    if (list) {
      setAddressList(list);
    }
  }, [list]);

  const handleDelete = (e, id) => {
    e.stopPropagation();

    const updatedList = addressList.filter((addr) => addr.id !== id);
    const keyName = isBilling
      ? BILLING_ADDRESS_LIST_KEY
      : SHIPPING_ADDRESS_LIST_KEY;
    if (updatedList.length <= 0) {
      localStorage.removeItem(keyName);
    } else {
      localStorage.setItem(keyName, JSON.stringify(updatedList));
    }
    setAddressList(updatedList);
    onRefreshAddressList(isBilling);
    if (updatedList.length === 0) {
      onHide();
    }
  };

  const getFormatedSelectedAddress = (address) => {
    if (isBilling) {
      return `${address.billingAddress}, ${address.city_name}, ${address.state_name} - ${address.billingPincode}`;
    }
    return `${address.shippingAddress}, ${address.shipping_cityname}, ${address.shipping_statename} - ${address.shippingPincode}`;
  };

  return (
    <Modal show={show} onHide={onHide} centered backdrop="static">
      <Modal.Header closeButton>
        <Modal.Title className={Styles.title}>
          {isSave ? "Save Address" : "Select Address"}
        </Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <div className={Styles.listContainer}>
          {addressList.map((item) => {
            return (
              <div
                key={item.id}
                className={`${Styles.addressCard} ${
                  !isSave ? Styles.selectableCard : ""
                }`}
                onClick={() => {
                  if (!isSave) {
                    onSelectAddress(item, isBilling);
                    onHide();
                  }
                }}
              >
                <div className={Styles.addressContent}>
                  <div className={Styles.addressHeader}>
                    <span className={Styles.addressTitle}>
                      {isBilling ? item.billingName : item.shippingName}
                    </span>
                    {!isSave && (
                      <img
                        src={deleteIcon}
                        alt="delete"
                        className={Styles.deleteIcon}
                        onClick={(e) => handleDelete(e, item.id)}
                      />
                    )}
                  </div>
                  <div className={Styles.addressText}>
                    {getFormatedSelectedAddress(item)}
                  </div>
                  <div className={Styles.phoneText}>
                    <strong>Ph.No:</strong>{" "}
                    {isBilling ? item.billingMobile : item.shippingMobile}
                  </div>
                  {((isBilling && item.billingEmail) ||
                    (!isBilling && item.shippingEmail)) && (
                    <div className={Styles.phoneText}>
                      <strong>Email:</strong>{" "}
                      {isBilling ? item.billingEmail : item.shippingEmail}
                    </div>
                  )}
                  {isBilling && item.gst_no && (
                    <div className={Styles.phoneText}>
                      <strong>GST No:</strong> {item.gst_no}
                    </div>
                  )}
                </div>

                {isSave && (
                  <button
                    className={Styles.itemSaveButton}
                    onClick={() => {
                      onUpdate(item.id, isBilling);
                      onHide();
                    }}
                  >
                    Update
                  </button>
                )}
              </div>
            );
          })}

          {addressList.length < 3 && isSave && (
            <div
              className={`${Styles.addressCard} ${Styles.addNewCard}`}
              onClick={() => {
                onNew(isBilling);
                onHide();
              }}
            >
              <img src={plusIcon} alt="add" className={Styles.plusIcon} />
              <div className={Styles.addNewText}>Add New Address</div>
            </div>
          )}
        </div>
      </Modal.Body>
    </Modal>
  );
}
